import React from 'react';
import { useNavigate } from 'react-router-dom';
import constants from '../config/consts';
import '../styles/ToyCard.css';

const ToyCard = ({ product, onClick }) => {
  const navigate = useNavigate();
  
  // Первое изображение из строки images (разделены запятой) или preViewImg
  const firstImage = product.images?.split(',')[0] || product.preViewImg;

  return (
    <div className="ToyCard" onClick={onClick}>
      <div className="toyCardImageContainer">
        <img className='toyCardImage'
          src={`${constants.serverUrl}${firstImage}`} 
          alt={product.title} 
        />
      </div>
      <p className="toyCardTitle">{product.title}</p>
      {product.category == 'Doodle Toys' && product.hight ? <p className="toyCardSize">{product.hight} см</p> : null}
      {product.price && <p className="toyCardPrice">{product.price} ₽</p>}
    </div>
  );
};

export default ToyCard;